<template>
  <div class="form">
    <Form2ItemInput
      v-model="identifier"
      ref="identifier"
      label="账号"
      :required="true"
      :disabled="true"
      max="11"
      @keyup-enter="submit"
      :rule="[{ type: `string`, required: true, message: `账号不能为空`, trigger: `blur` }]"
    />
    <Form2ItemInput
      v-model="credential"
      ref="credential"
      label="登录密码"
      type="password"
      :required="true"
      max="30"
      @keyup-enter="submit"
      :rule="[{ type: `string`, required: true, message: `登录密码不能为空`, trigger: `blur` }]"
    />
    <div>
      <Button @click="$router.push(`/user/safe/list`)">
        取消
      </Button>
      <Button
        class="ml"
        type="primary"
        @click="submit">
        下一步
      </Button>
    </div>
  </div>
</template>

<script>
import {updateMobileVerify} from '@/service';
import {encrypt} from '@/util';
import Form2ItemInput from '@/components/form2-item-input';
export default {
  components: {Form2ItemInput},
  data() {
    return {
      identifier: '',
      credential: '',
    };
  },
  watch: {
    '$store.state.user.userAuth.identifier'(value) {
      this.identifier = value;
    },
  },
  methods: {
    submit() {
      Promise.all([
        this.$refs['identifier'].validate(),
        this.$refs['credential'].validate(),
      ]).then(([valid1, valid2]) => {
        if (valid1 && valid2) {
          updateMobileVerify({
            identifier: this.identifier,
            credential: encrypt(this.credential),
          }).then(({result, resultDesc}) => {
            if (result === true) {
              this.$emit('success');
            } else {
              this.$Message.success(resultDesc);
            }
          });
        }
      });
    },
  },
  mounted() {
    if (this.$store.state.user.userAuth.identifier) {
      this.identifier = JSON.parse(JSON.stringify(this.$store.state.user.userAuth.identifier));
    }
  },
};
</script>
